const contactus = {
  path: 'contactus',
  component: resolve => require(['../../../../pages/modules/contact-us'], resolve),
  meta: {
    requireAuth: true
  }
}

export default contactus
